import React, { Component } from "react"
import axios from '../../axios'
import fp from 'lodash/fp'
import Alert from 'react-s-alert'
import Paging from '../../components/Paging'
import qs from 'qs'

class DataPasien extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dataPasien          : [],
            pageCount           : 0,
            currentPage         : 0,
            filter_keyword      : "",
            isLoading           : true
        }

        this.handleChange       = this.handleChange.bind(this)
        this.handlePageClick    = this.handlePageClick.bind(this)
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    }

    loadData() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            keyword     : this.state.filter_keyword,
            page        : this.state.currentPage + 1,
        })

        axios({
            method: "get",
            url: "/rumah_sakit/getDataPasien?" + params
        })
            .then(response => {

                const result = response.data

                this.setState({
                    dataPasien  : result.data,
                    pageCount   : result.last_page,
                    isLoading   : false
                })
            })
            .catch(error => {
                console.log(error)
            
                this.setState({isLoading: false})

                Alert.error("Tidak dapat terhubung ke server");
            })
    }

    componentDidMount() {
        this.loadData()
    }

    componentDidUpdate(nextProps, nextState) {
        if (nextState.filter_keyword !== this.state.filter_keyword) {
            
            this.setState({pageCount: 0, currentPage: 0},() => {
                this.loadData()
            })
        }
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-header">
                                Data Pasien
                            </div>
                            <div className="card-block">
                                <div style={{marginBottom: "30px"}}>
                                    <div className="form-group row">
                                        <div className="col-md-12">
                                            <label className="form-form-control-label text-muted">Filter Data</label>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                name="filter_keyword"
                                                className="form-control"
                                                onChange={this.handleChange}
                                                value={this.state.filter_keyword}
                                                placeholder="Ketik Nama Pasien / Nomor Rekam Medis ..."/>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.isLoading ? "Memuat Data ..." : (
                                        this.state.dataPasien.length === 0 ? "Data Kosong ..." : (
                                            <div>
                                                <table className="table table-bordered table-striped">
                                                    <thead>
                                                    <tr>
                                                        <th>Nama</th>
                                                        <th>No. Rekam Medis</th>
                                                        <th>NIK</th>
                                                        <th>No. Jamkesmas</th>
                                                        <th>Jenis Kelamin</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.dataPasien.map(item => (
                                                            <tr>
                                                                <td>{item.nama_anggota}</td>
                                                                <td>{item.no_rm}</td>
                                                                <td>{item.nik}</td>
                                                                <td>{item.kesehatan_no_jamkesmas}</td>
                                                                <td>{fp.startCase(item.jenis_kelamin)}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                    </tbody>
                                                </table>
                                                
                                                <Paging 
                                                    handlePageClick={this.handlePageClick}
                                                    pageCount={this.state.pageCount}
                                                    currentPage={this.state.currentPage}
                                                />
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DataPasien;


// WEBPACK FOOTER //
// ./src/views/DataPasien/index.js